<template>
    <div class="appointments-nav" :class="{fixed: fixed}" :style="styles">
        <div>
            <a class="appointment-prev"
               :class="{disabled: !canGoBack()}"
               href="#"
               @click.prevent="goBack"
            >
                <span class="sr-only">Prev</span>
            </a>

            <a class="appointment-next"
               :class="{disabled: !canGoForward()}"
               href="#"
               @click.prevent="goForward"
            >
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'appointments-nav',

        props: {
            startDate: {
                type: Object,
                required: true,
            },

            fixed: {
                type: Boolean,
                default: () => false,
            },

            left: {
                type: Number,
                default: () => 0,
            },

            right: {
                type: Number,
                default: () => 0,
            },
        },

        computed: {
            styles() {
                if (this.fixed) {
                    return {
                        left: `${this.left}px`,
                        right: `${this.right}px`,
                        width: 'auto',
                    };
                }

                return {};
            },
        },

        methods: {
            canGoBack() {
                const now = window.moment().startOf('day');

                return now.isBefore(this.startDate);
            },

            canGoForward() {
                const maxDate = window.moment().startOf('day').add(process.env.VUE_APP_MAX_DAYS, 'day');
                const nextDate = window.moment(this.startDate).startOf('day').add(5, 'day');

                return nextDate.isSameOrBefore(maxDate);
            },

            goBack() {
                if (this.canGoBack()) {
                    this.$emit('back');
                }
            },

            goForward() {
                if (this.canGoForward()) {
                    this.$emit('forward');
                }
            },
        }
    }
</script>
